import { render } from "./CopyrightView.vue?vue&type=template&id=558093b7&scoped=true"
import script from "./CopyrightView.vue?vue&type=script&lang=js"
export * from "./CopyrightView.vue?vue&type=script&lang=js"

import "../assets/css/common.css?vue&type=style&index=0&lang=css"
import "../assets/css/Privacy.css?vue&type=style&index=1&id=558093b7&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\national-museum-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-558093b7"]])

export default __exports__